import { useState } from "react";

export const SurveyMeter2 = ({
  label,
  levels,
  name,
  value,
  setValue,
  customImages,
  enhancedBrightness,
  meterContainerStyle,
  meterBaseColor,
  containerClass,
  worstLabel,
  bestLabel,
}) => {
  const [hoveredLevel, setHoveredLevel] = useState();
  const [selectedLevel, setSelectedLevel] = useState();
  const selectedLevelValue = value ?? selectedLevel;

  const levelToDisplay =
    hoveredLevel != undefined ? hoveredLevel : selectedLevelValue;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "stretch",
        marginBottom: "1rem",
        ...meterContainerStyle,
      }}
      className={containerClass}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {label}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {worstLabel && <span className="font-600 tw-mr-2">{worstLabel}</span>}
          <div
            onMouseLeave={() => {
              setHoveredLevel();
            }}
            style={{
              height: "55px",
              display: "flex",
              flex: 1,
            }}
          >
            {Array.from({ length: levels }).map((_, index) => {
              const selectionValue = index + 1;
              return (
                <div
                  key={selectionValue}
                  onMouseEnter={() => {
                    setHoveredLevel(selectionValue);
                  }}
                  onClick={() => {
                    // setSelectedLevel(index);
                    setValue
                      ? setValue({
                          target: { name: name, value: selectionValue },
                        })
                      : setSelectedLevel(selectionValue);
                  }}
                  className="survey-meter-bar-container"
                  style={{
                    cursor: "pointer",
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="survey-meter-bar"
                    style={{
                      height: "15px",
                      flex: 1,
                      backgroundColor: (
                        hoveredLevel != undefined
                          ? selectionValue <= hoveredLevel
                          : selectionValue <= selectedLevelValue
                      )
                        ? // "#03d725"
                          `hsl(${
                            hoveredLevel != undefined
                              ? (145 / levels) * levelToDisplay
                              : (145 / levels) * selectedLevelValue
                          }, 97%, 43%)`
                        : meterBaseColor ?? "#9d9d9d",
                    }}
                  ></div>
                </div>
              );
            })}
          </div>
          {bestLabel && <span className="font-600 tw-ml-2">{bestLabel}</span>}
        </div>
      </div>
      {/* <div
        style={{
          display: "grid",
          placeContent: "start",
          padding: ".5rem",
        }}
      >
        {(selectedLevel !== undefined || hoveredLevel !== undefined) && (
          <>
            <div
              style={{
                width: "90px",
                height: "90px",
                overflow: "hidden",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  filter:
                    enhancedBrightness && levelToDisplay == 1
                      ? "brightness(1.7)"
                      : "",
                  transform: enhancedBrightness
                    ? levelToDisplay == 2
                      ? "scale(1.7) translate(0px, 19px)"
                      : levelToDisplay == 1
                      ? "scale(1.2) translate(0px, 10px)"
                      : "scale(1.3) translate(7px, 7px)"
                    : null,
                }}
                src={
                  customImages
                    ? customImages[
                        hoveredLevel !== undefined
                          ? hoveredLevel
                          : selectedLevel
                      ]
                    : levelImages[
                        hoveredLevel !== undefined
                          ? hoveredLevel
                          : selectedLevel
                      ]
                }
              />
            </div>
          </>
        )}
      </div> */}
    </div>
  );
};
